var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// @todo [refactoring] [priority-1]
import axios from 'axios';
import pickBy from 'lodash/pickBy';
import { OCCUPATION_TYPES, } from '../pages/MainFormPage/formPages/ApplicantOccupationPage/formModel.types';
import { miscErrors } from '../utils/miscErrors';
import { UTMUtils } from '../utils/UTM.utils';
import { phoneUtils } from '../utils/phone.utils';
function makeHouseholdsDTOFromApplicantFields(data, mortgageCaseMeta) {
    var _a;
    var applicant = data.applicant, secondApplicant = data.secondApplicant, isSameHousehold = data.isSameHousehold, applicantsCount = data.applicantsCount, maritalStatus = data.maritalStatus;
    var hasSecondApplicant = applicantsCount === 2;
    if (mortgageCaseMeta && mortgageCaseMeta.firstApplicantInternalId === null) {
        throw miscErrors.makeMortgageCaseMetaUnassignedFieldError('firstApplicantInternalId');
    }
    var extendedApplicant = __assign(__assign(__assign(__assign({}, applicant), (hasSecondApplicant &&
        typeof maritalStatus !== 'undefined' && {
        maritalStatus: maritalStatus,
    })), (mortgageCaseMeta && {
        internalId: mortgageCaseMeta.firstApplicantInternalId,
    })), { contact2: __assign(__assign({}, applicant === null || applicant === void 0 ? void 0 : applicant.contact2), { number: phoneUtils.getPureString((_a = applicant === null || applicant === void 0 ? void 0 : applicant.contact2) === null || _a === void 0 ? void 0 : _a.number) }) });
    if (!hasSecondApplicant) {
        return {
            household: { applicant: extendedApplicant },
        };
    }
    var extendedSecondApplicant = __assign(__assign(__assign({}, secondApplicant), (typeof maritalStatus !== 'undefined' && {
        maritalStatus: maritalStatus,
    })), (mortgageCaseMeta &&
        mortgageCaseMeta.secondApplicantInternalId && {
        internalId: mortgageCaseMeta.secondApplicantInternalId,
    }));
    if (isSameHousehold) {
        return {
            household: {
                applicant: extendedApplicant,
                secondApplicant: extendedSecondApplicant,
            },
        };
    }
    return {
        household: { applicant: extendedApplicant },
        secondHousehold: { applicant: extendedSecondApplicant },
    };
}
function makeSourceMetaDTOFromSourceCaseMeta(sourceCaseMeta) {
    var smavaCustomerNumber = sourceCaseMeta.smavaCustomerNumber, placementId = sourceCaseMeta.placementId, loanCategory = sourceCaseMeta.loanCategory, switchingBucket = sourceCaseMeta.switchingBucket, customerIp = sourceCaseMeta.customerIp, audienceMarkerMeta = sourceCaseMeta.audienceMarkerMeta, isCRMLead = sourceCaseMeta.isCRMLead, referralData = sourceCaseMeta.referralData;
    var base = pickBy({
        smavaCustomerNumber: smavaCustomerNumber,
        placementId: placementId,
        loanPurposeLandingPage: loanCategory,
        optimizelyParameter: switchingBucket,
        consentIp: customerIp,
        crmLead: isCRMLead,
        referral: referralData,
    }, function (val) { return typeof val !== 'undefined' && val !== null; });
    return __assign(__assign({}, base), (audienceMarkerMeta &&
        UTMUtils.isAudienceMarkerContainsUTM(audienceMarkerMeta) && {
        utmParameters: pickBy({
            utmSource: audienceMarkerMeta.utm_source,
            utmMedium: audienceMarkerMeta.utm_medium,
            utmCampaign: audienceMarkerMeta.utm_campaign,
        }, function (val) { return typeof val !== 'undefined'; }),
    }));
}
function makeOccupationDTOFromApplicantOccupationFields(occupationData) {
    var commonPart = __assign(__assign({ type: occupationData.occupationType }, (occupationData.isOnProbationPeriod && {
        begin: occupationData.occupationBegin,
    })), (occupationData.isLimitedOccupation && {
        limitedUntil: occupationData.occupationLimitedUntil,
    }));
    switch (commonPart.type) {
        case OCCUPATION_TYPES.EMPLOYEE:
        case OCCUPATION_TYPES.WORKER:
        case OCCUPATION_TYPES.OFFICER:
            return __assign(__assign(__assign(__assign(__assign({}, commonPart), { type: commonPart.type, monthlyNetSalary: occupationData.income }), (occupationData.numberOfSalariesPerYear && {
                numberOfSalariesPerYear: occupationData.numberOfSalariesPerYear,
            })), (occupationData.isOnProbationPeriod && {
                inProbationPeriod: occupationData.isOnProbationPeriod,
            })), (typeof occupationData.employerAddressCountry !== 'undefined' && {
                employerAddress: {
                    country: occupationData.employerAddressCountry,
                },
            }));
        case OCCUPATION_TYPES.PENSIONER:
            return __assign(__assign(__assign({}, commonPart), { type: commonPart.type, monthlyNetSalary: occupationData.income }), (typeof occupationData.employerAddressCountry !== 'undefined' && {
                employerAddress: {
                    country: occupationData.employerAddressCountry,
                },
            }));
        case OCCUPATION_TYPES.SELF_EMPLOYED:
        case OCCUPATION_TYPES.FREELANCER:
            return __assign(__assign({}, commonPart), { type: commonPart.type, annualEarnings: [
                    {
                        earningsAfterTaxes: occupationData.income,
                    },
                ] });
        case OCCUPATION_TYPES.RETIREE:
        case OCCUPATION_TYPES.UNEMPLOYED:
        case OCCUPATION_TYPES.HOUSEMAKER:
            return __assign(__assign({}, commonPart), { type: commonPart.type, monthlyNetPublicBenefit: occupationData.income });
    }
}
function makeApplicantsOccupationDTOFromApplicantOccupationFields(applicantFields, occupationFields, mortgageCaseMeta) {
    var applicantsCount = applicantFields.applicantsCount;
    if (mortgageCaseMeta.firstApplicantInternalId === null) {
        throw miscErrors.makeMortgageCaseMetaUnassignedFieldError('firstApplicantInternalId');
    }
    if (applicantsCount === 2 &&
        mortgageCaseMeta.secondApplicantInternalId === null) {
        throw miscErrors.makeMortgageCaseMetaUnassignedFieldError('secondApplicantInternalId');
    }
    var applicant = {
        internalId: mortgageCaseMeta.firstApplicantInternalId,
        occupations: [
            makeOccupationDTOFromApplicantOccupationFields(occupationFields.applicant),
        ],
    };
    var secondApplicant = applicantsCount === 2
        ? {
            internalId: mortgageCaseMeta.secondApplicantInternalId,
            occupations: [
                // @todo: possible vulnerability with "as". Types should be redefined!!!
                makeOccupationDTOFromApplicantOccupationFields(occupationFields.secondApplicant),
            ],
        }
        : null;
    if (occupationFields.isSameHousehold) {
        return {
            caseId: mortgageCaseMeta.caseId,
            household: __assign(__assign({ internalId: mortgageCaseMeta.firstHouseholdId, applicant: applicant }, (secondApplicant && { secondApplicant: secondApplicant })), { livingAddress: __assign(__assign({}, occupationFields.applicant.postalAddress), { country: 'DE' }) }),
        };
    }
    return __assign({ caseId: mortgageCaseMeta.caseId, household: {
            internalId: mortgageCaseMeta.firstHouseholdId,
            applicant: applicant,
            livingAddress: __assign(__assign({}, occupationFields.applicant.postalAddress), { country: 'DE' }),
        } }, (occupationFields.applicantsAmount === 2 &&
        occupationFields.secondApplicant &&
        secondApplicant !== null && {
        secondHousehold: {
            internalId: mortgageCaseMeta.secondHouseholdId,
            applicant: secondApplicant,
            livingAddress: __assign(__assign({}, occupationFields.secondApplicant.postalAddress), { country: 'DE' }),
        },
    }));
}
function makeUpdateApplicantContactDTOfromAdviceFields(adviceFields, mortgageCaseMeta) {
    if (mortgageCaseMeta.caseId === null) {
        throw miscErrors.makeMortgageCaseMetaUnassignedFieldError('caseId');
    }
    if (mortgageCaseMeta.firstApplicantInternalId === null) {
        throw miscErrors.makeMortgageCaseMetaUnassignedFieldError('firstApplicantInternalId');
    }
    return __assign(__assign({ caseid: mortgageCaseMeta.caseId, applicantId: mortgageCaseMeta.firstApplicantInternalId }, adviceFields), { availabilities: [] });
}
export var helpers = {
    getMortgageCaseMetaFromSaveApplicantResponse: function (data) {
        var caseId = data.caseId, household = data.household;
        var firstApplicantInternalId = household.applicant.internalId;
        var firstHouseholdId = household.internalId;
        var secondApplicantInternalId = null;
        var secondHouseholdId = null;
        if ('secondApplicant' in household) {
            secondApplicantInternalId = household.secondApplicant.internalId;
        }
        if ('secondHousehold' in data) {
            secondHouseholdId = data.secondHousehold.internalId;
            secondApplicantInternalId = data.secondHousehold.applicant.internalId;
        }
        return {
            caseId: caseId,
            firstApplicantInternalId: firstApplicantInternalId,
            secondApplicantInternalId: secondApplicantInternalId,
            firstHouseholdId: firstHouseholdId,
            secondHouseholdId: secondHouseholdId,
        };
    },
};
export var applicantService = {
    saveApplicants: function (data, sourceCaseMeta) {
        return __awaiter(this, void 0, Promise, function () {
            var requestBody;
            return __generator(this, function (_a) {
                requestBody = __assign(__assign({}, makeSourceMetaDTOFromSourceCaseMeta(sourceCaseMeta)), makeHouseholdsDTOFromApplicantFields(data));
                return [2 /*return*/, axios.post('/api/applicants', requestBody)];
            });
        });
    },
    updateApplicantOccupation: function (applicants, occupation, mortgageCaseMeta) {
        return __awaiter(this, void 0, Promise, function () {
            var requestBody;
            return __generator(this, function (_a) {
                if (mortgageCaseMeta.caseId === null) {
                    throw miscErrors.makeMortgageCaseMetaUnassignedFieldError('caseId');
                }
                requestBody = makeApplicantsOccupationDTOFromApplicantOccupationFields(applicants, occupation, mortgageCaseMeta);
                return [2 /*return*/, axios.put('/api/applicant/update-with-income', requestBody)];
            });
        });
    },
    updateApplicantContact: function (adviceFields, mortgageCaseMeta) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, axios.put('/api/applicant/contact/availability', makeUpdateApplicantContactDTOfromAdviceFields(adviceFields, mortgageCaseMeta))];
            });
        });
    },
};
